// Meu Radar no Comercial (24/09/2026) — Meu Radar + Atividades, lado a lado.
//
// Pedido do Gustavo (gerente comercial): o radar fica SÓ no Comercial, com a
// aba "Atividades" ao lado — a MESMA tela de Atividades do Administrativo e do
// Financeiro, filtrada no módulo comercial. Até aqui o radar era item próprio
// do Administrativo (/meu-radar, `groups: []`), aberto a todo profissional.
//
// 🚨 A aba Atividades monta o componente `Atividades` de pages/Atividades.tsx
// com `moduloFixo="comercial"`, e não uma cópia: são três telas de Atividades
// (Administrativo, Financeiro, Comercial) e uma régua só de filtro, kanban e
// calendário. Uma quarta cópia divergiria na primeira manutenção.
//
// O "ir para a origem" da atividade comercial só NAVEGA para o Pipeline — o
// Pipeline não é tocado por esta entrega (decisão do Gustavo, 24/09/2026:
// "não quero mexer no pipeline").
import { useNavigate } from 'react-router-dom';
import HubAbas, { HubTab } from '../../components/HubAbas';
import MeuRadar from '../meu-radar/MeuRadar';
import Atividades from '../Atividades';

export default function ComercialRadarHub() {
  const navigate = useNavigate();
  const tabs: HubTab[] = [
    { key: 'radar',      label: '📡 Meu Radar',  perm: 'radar.meu.ver',          render: () => <MeuRadar /> },
    {
      key: 'atividades', label: '✓ Atividades', perm: 'comercial.pipeline.ver',
      render: () => (
        <Atividades
          moduloFixo="comercial"
          onIrParaOrigem={(modulo) => {
            if (modulo === 'comercial') navigate('/comercial/pipeline');
          }}
        />
      ),
    },
  ];
  return <HubAbas tabs={tabs} />;
}
